import { useOutletContext } from 'react-router-dom';

import type { EventChallenge } from '@/config/objects/events';

export interface ChallengeDetailOutletContext {
  challenge: EventChallenge;
  eventId: string;
  challengeId: string;
}

export function useChallengeDetailContext(): ChallengeDetailOutletContext {
  return useOutletContext<ChallengeDetailOutletContext>();
}
